// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-popup-parent--hidden {\n  padding-right: unset !important;\n}\n.recycle_tooltip.el-tooltip__popper {\n  max-width: 18%;\n  line-height: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
